import React from 'react';
import { useState, useEffect } from "react";

import carbonis from "../carbonis.png";
import { UilEnvelopeShield } from '@iconscout/react-unicons';
import { UilCreateDashboard } from '@iconscout/react-unicons'
import axios from 'axios';

//Set base URL
const baseUrl = "https://plum-defiant-lamb.cyclic.app/user";
// const baseUrl = "localhost:8000/user";

const emailFilter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

let verified = false;

export default function Register() {

    const wallet_address = localStorage.getItem('wallet_address');

    const [userData, setUser] = useState({
        email: '',
        name: '',
        address: wallet_address,
        confirmEmail: ''
    });

    useEffect(() => {
        getUser();
    }, [])

    const handleChange = (event) => {
        setUser({
            ...userData,
            [event.target.name]: event.target.value
        });
    }

    async function createUser(event) {
        event.preventDefault();

        console.log(userData);

        try {
            const response = await axios({
                method: 'post',
                url: `${baseUrl}/signup`,
                data: userData,
                headers: { "Content-Type": "application/json" }
            })

            setUser({
                email: '',
                name: '',
                confirmEmail: '',
            });

            verified = true;
        } catch (error) {
            console.error(`Error while sending the data : ${error}`);
        }
    }

    async function getUser() {
        try {
            const response = await axios.get(`${baseUrl}/details?wallet=${localStorage.getItem('wallet_address')}`);
            console.log('User data : ', response.data);
            if (response.data !== null) {
                window.location = '/dashboard-2';
            }

            // setCounter('1');
        } catch (error) {
            console.error(error);
        }
    }

    // if (!!wallet_address) getUser();

    return (
        <div>
            <div className="is-center">
                <img src={carbonis} style={{ width: '200px', marginBottom: "50px", marginTop: "50px" }}></img>
            </div>
            <div className="columns section">
                <div className="column"></div>
                <div className="field column">
                    <div className="control has-icons-left has-icons-right">


                        {!verified ? (
                            <div>
                                <h2 style={{ margin: '20px auto' }}>Please enter your details to verify</h2>
                                <form onSubmit={createUser}>
                                    <input id="name" className="input" type="text" name="name" placeholder="Name" value={userData.name} onChange={handleChange} style={{ marginBottom: "20px" }} />

                                    <input id="email" className="input" type="email" name="email" placeholder="Email" value={userData.email} onChange={handleChange} style={{ marginBottom: "20px" }} />

                                    <input id="confirmEmail" className="input" type="email" name="confirmEmail" placeholder="Confirm Email"
                                        value={userData.confirmEmail} onChange={handleChange} style={{ marginBottom: "20px" }} />

                                    <input id="wallet_address" disabled className="input" type="test" name="wallet_address" placeholder="Wallet Address" value={wallet_address.substring(0, 10) + '...' + wallet_address.substring(wallet_address.length - 10)} style={{ marginBottom: "20px" }} />

                                    <p>
                                        {userData.confirmEmail === userData.email && userData.name.length > 0 && userData.email.length > 0 ? (<button type="submit" className="button is-black margin-top-bottom-50"> <UilEnvelopeShield /> &nbsp;&nbsp;Verify </button>) : (
                                            <span style={{ color: 'red' }}>Email addresses do not match <br /> Please fill in all the required details.</span>
                                        )}

                                    </p>
                                </form>
                            </div>
                        ) : (
                            <p>
                                Thanks for verifying! You have been added to the waitlist. 🌳

                                <button onClick={window.location = '/dashboard-2'} className="button is-black margin-top-bottom-50" > <UilCreateDashboard /> &nbsp;&nbsp;
                                    Go to Dashboard
                                </button>
                            </p>
                        )}

                    </div>
                </div>
                <div className="column"></div>
            </div>
        </div>
    )
}
